import { toastError, toastSuccess } from "../redux/guest-slices/other.slice"
import { checkTokenErr } from "../utils/helper"
import axios from "axios"

class ApiServices {

  async request(
    axiosConfig,
    thunkAPI,
    {
      successMsg = null,
      errorToast = true,
      successToast = true,
    } = {}
  ) {
    const { dispatch, rejectWithValue } = thunkAPI

    try {
      const response = await axios(axiosConfig)

      if (response.data?.success) {
        if (successToast) {
          dispatch(toastSuccess(successMsg || response.data?.message))
        }
        return response.data?.data ?? response.data
      }

      const errorMsg = response.data?.error || "Something went wrong!"
      if (errorToast) dispatch(toastError(errorMsg))
      return rejectWithValue(errorMsg)

    } catch (error) {
      checkTokenErr(error, dispatch)
      const errorMsg = error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Something went wrong!"
      if (errorToast) dispatch(toastError(errorMsg))
      return {}
    }
  }
}

export default ApiServices